class TransparentHeader {
    constructor() {
        this.siteHeader = document.querySelector('.site-header');
        this.headerLogo = document.querySelector('.site-header .logo');
        this.nav = document.querySelector('.site-header .nav');
        this.announcementBar = document.querySelector('.announcement-bar-static');
        this.mobileMenu = document.querySelector('.site-header .mobile-menu');
        this.mobileMenuBtn = document.querySelector('.site-header .mobile-menu__button--burger');
        this.init();
    }

    init() {
        if (!this.siteHeader || !this.announcementBar) return;
        this.observeClassChanges();
        this.updateHeaderTransparency();
        this.updateHeaderHeights();
        window.addEventListener('resize', this.updateHeaderHeights.bind(this));
    }

    observeClassChanges() {
        const observer = new MutationObserver(() => {
            this.updateHeaderTransparency();
            this.updateHeaderHeights();
        });

        observer.observe(this.siteHeader, { attributes: true, attributeFilter: ['class'] });
    }

    findAnnouncementBarHeight() {
        let height = this.announcementBar.offsetHeight;
        if (this.siteHeader.classList.contains('site-header--compress')) {
            return height + 10;
        }
        return height + 30;
    }

    updateHeaderHeights() {
        const headerHeight = this.siteHeader.offsetHeight;
        document.documentElement.style.setProperty('--header-height-custom-adjust', `${headerHeight}px`);
    }

    updateHeaderTransparency() {
        const announcementBarHeight = this.findAnnouncementBarHeight();
        const isTransparent = this.siteHeader.classList.contains('site-header__announcement-bar--transparent') &&
            this.siteHeader.classList.contains('site-header--transparent');

        document.body.classList.toggle('announcement-bar--transparent', isTransparent);

        if (isTransparent) {
            this.headerLogo.style.marginTop = announcementBarHeight + 12 + 'px';
            this.nav.style.paddingTop = announcementBarHeight + 5 + 'px';
        } else {
            this.headerLogo.style.marginTop = '';
            this.nav.style.paddingTop = '';
        }
    }
}
document.addEventListener('shopify:section:load', () => {
    new TransparentHeader();
});
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.site-header')) {
        new TransparentHeader();
    }
});

class BorderRadiusAnimation {
    constructor() {
        this.iconsRowSection = document.querySelector('.shopify-section:has(.icons-row--top-border-radius)');
        this.iconsRowCtr = document.querySelector('.icons-row--top-border-radius');
        this.init();
    }

    init() {
       if (!this.iconsRowSection && !this.iconsRowCtr) return;
       window.addEventListener('scroll', () => this.handleScroll());
       window.addEventListener('resize', () => this.handleScroll());
       this.handleScroll;
    }

    handleScroll() {
        const windowWidth = window.innerWidth;
        if(this.iconsRowSection) {
            this.updateBorderRadius(this.iconsRowSection, windowWidth);
        }
        if(this.iconsRowCtr) {
            this.updateBorderRadius(this.iconsRowCtr, windowWidth);
        }
    }

    updateBorderRadius(element, windowWidth) {
        const sectionTop = element.getBoundingClientRect().top;
        const viewPortHeight = window.innerHeight;

        const scrollRatio = Math.max(0, Math.min(1, ((viewPortHeight - sectionTop) / viewPortHeight) * 1.10));

        let baseRadius = 0.5;
        let minRadius = 100;

        if(windowWidth < 1400) {
            baseRadius = 0.4;
        }

        if(windowWidth < 768) {
            baseRadius = 0.3;
            minRadius = 50;
        }

        let borderRadius = (windowWidth * baseRadius) - scrollRatio * ((windowWidth * baseRadius) - minRadius);
        borderRadius = Math.max(borderRadius, minRadius);

        element.style.borderRadius = `${borderRadius}px ${borderRadius}px 0 0`;
    }

}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.icons-row--top-border-radius')) {
        new BorderRadiusAnimation();
    }
});

class MoveRechargeWidget {
    constructor() {
        this.rechargeWidget = document.querySelector('.product-single .rc-container-wrapper');
        this.productForm = document.querySelector('.product-single .product__form');
        this.productSubmitHolder = document.querySelector('.product-single .product__submit__holder');
        this.rcWidget = document.querySelector('.product-single .rc_container');
        this.init();
    }

    init() {
        this.waitForRechargeWidget().then(() => {
            this.relocate();

            this.rechargeWidget = document.querySelector('.product-single .rc-container-wrapper');
            this.rcWidget = document.querySelector('.product-single .rc_container');

            const label = document.createElement("span");
            label.className = "select__label";
            label.textContent = "Frequency";
            if (this.rechargeWidget && this.rcWidget) {
                this.rechargeWidget.insertBefore(label, this.rcWidget);
            } else {
                console.error("Recharge widget or RC widget not found after relocate.");
            }
        });
    }

    waitForRechargeWidget() {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                this.rechargeWidget = document.querySelector('.product-single .rc-container-wrapper');
                if (this.rechargeWidget) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
    }

    relocate() {
        if (this.rechargeWidget) {
            this.rechargeWidget.remove();
            this.productForm.insertBefore(this.rechargeWidget, this.productSubmitHolder);
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.product-single')) {
        new MoveRechargeWidget();
    }
});
